import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  fill: "none",
  viewBox: "0 0 22 22",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M14.5.5H.5v14h14V.5ZM6.1 5.4A1.4 1.4 0 0 1 7.5 4h.176C8.352 4 8.9 4.548 8.9 5.224c0 .375-.15.735-.415 1L7.5 7.21a2.39 2.39 0 0 0-.7 1.69h1.4a.99.99 0 0 1 .29-.7l.985-.985a2.816 2.816 0 0 0 .825-1.991A2.624 2.624 0 0 0 7.676 2.6H7.5a2.8 2.8 0 0 0-2.8 2.8v.7h1.4v-.7Zm1.4 4.9a1.05 1.05 0 1 0 0 2.1 1.05 1.05 0 0 0 0-2.1Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M18 3h-2v13H3v2h15V3Z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M19.5 6.5h2v15h-15v-2h13v-13Z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }